import initialState from "./InitialState"
import {
    FETCH_ALL_STATIC_DATA_SUCCESS_NEW,
    FETCH_FOOD_GROUPS_DATA_SUCCESS, FETCH_PLAN_STATIC_DATA_SUCCESS, FETCH_LAB_TESTS_SUCCESS
} from "../actions/ActionTypes"
import {combineReducers} from "redux"

const vitalListReducer = (state = initialState.allStaticDataNew.vitalList, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.vitalList);
        default:
            return state;
    }
};

const habitListReducer = (state = initialState.allStaticDataNew.habitList, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.habitList);
        default:
            return state;
    }
};

const specialistCodeListReducer = (state = initialState.allStaticDataNew.doctorSpecialityResponseList, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.doctorTypeResponseList);
        default:
            return state;
    }
};

const MedicineTypeReducer = (state = initialState.allStaticDataNew.medicalTypeList, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.medicalTypeCodes);
        default:
            return state;
    }
};

const StaticDietRecallDataReducer = (state = initialState.allStaticDataNew.staticDietRecallData, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.staticDietRecallData);
        default:
            return state;
    }
};

const surgeryReducer = (state = initialState.allStaticDataNew.surgery, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.surgery);
        default:
            return state;
    }
};

const allergyReducer = (state = initialState.allStaticDataNew.allergy, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.allergy);
        default:
            return state;
    }
};

const lifeStyleReducer = (state = initialState.allStaticDataNew.lifeStyleProfile, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.lifeStyleProfile);
        default:
            return state;
    }
};

const habitReducer = (state = initialState.allStaticDataNew.habits, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.habits);
        default:
            return state;
    }
};

const pastConditionsReducer = (state = initialState.allStaticDataNew.pastConditions, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.pastConditions);
        default:
            return state;
    }
};

const redFlagsReducer = (state = initialState.allStaticDataNew.redFlags, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.redFlags);
        default:
            return state;
    }
};

const generalExamsReducer = (state = initialState.allStaticDataNew.generalExaminations, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.generalExaminations);
        default:
            return state;
    }
};

const systemicExamsReducer = (state = initialState.allStaticDataNew.systemicExaminations, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.systemicExaminations);
        default:
            return state;
    }
};

const entExamsReducer = (state = initialState.allStaticDataNew.entExaminations, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.entExaminations);
        default:
            return state;
    }
};

const mentalStatusExamsReducer = (state = initialState.allStaticDataNew.mentalStatusExaminations, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.mentalStatusExaminations);
        default:
            return state;
    }
};

const reviewSystemsReducer = (state = initialState.allStaticDataNew.reviewOfSystems, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.reviewOfSystems);
        default:
            return state;
    }
}

const personalInfoReducer = (state = initialState.allStaticDataNew.personalInformation, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.personalInformation);
        default:
            return state;
    }
}
const personInformationPhysiotherapistReducer= (state = initialState.allStaticDataNew.personalInformationPhysiotherapist, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.personalInformationPhysiotherapist);
        default:
            return state;
    }
}

const mindfulnessInfoReducer = (state = initialState.allStaticDataNew.mindfulnessInformation, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.mindfulnessInformation);
        default:
            return state;
    }
}

const foodTypesReducer = (state = initialState.allStaticDataNew.allPreferredFoodTypes, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.allPreferredFoodTypes);
        default:
            return state;
    }
}

const cuisinesInfoReducer = (state = initialState.allStaticDataNew.allPreferredCuisines, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.allPreferredCuisines);
        default:
            return state;
    }
}

const routineActivitiesReducer = (state = initialState.allStaticDataNew.routineActivities, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.routineActivities);
        default:
            return state;
    }
}

const foodGroupsReducer = (state = initialState.allStaticDataNew.foodGroups, action: any) => {
    switch (action.type) {
        case FETCH_FOOD_GROUPS_DATA_SUCCESS:
            return Object.assign({}, action.foodGroups);
        default:
            return state;
    }
}

const lifestylePlanHabitsReducer = (state = initialState.allStaticDataNew.lifestylePlanHabits, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.lifestylePlanHabits);
        default:
            return state;
    }
}

const typeFormReducer = (state = initialState.allStaticDataNew.typeFormMapping, action: any) => {
    switch (action.type) {
        default:
            return state;
    }
}

const goalsReducer = (state = initialState.allStaticDataNew.goals, action: any) => {
    switch (action.type) {
        case FETCH_PLAN_STATIC_DATA_SUCCESS:
            return Object.assign({}, action.planStaticData.goals);
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.goals);
        default:
            return state;
    }
}

const metricsReducer = (state = initialState.allStaticDataNew.metrics, action: any) => {
    switch (action.type) {
        case FETCH_PLAN_STATIC_DATA_SUCCESS:
            return Object.assign({}, action.planStaticData.metrics);
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.metrics);
        case FETCH_LAB_TESTS_SUCCESS:
            return Object.assign({}, action.allStaticData.metrics);
        default:
            return state;
    }
}

const trackableSymptomsReducer = (state = initialState.allStaticDataNew.trackableSymptoms, action: any) => {
    switch (action.type) {
        case FETCH_PLAN_STATIC_DATA_SUCCESS:
            return Object.assign([], action.planStaticData.trackableSymptoms);
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign([], action.allStaticData.trackableSymptoms);
        default:
            return state;
    }
}

const fitnessRecallInfoReducer = (state = initialState.allStaticDataNew.fitnessRecallInformation, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, action.allStaticData.fitnessRecallInformation);
        default:
            return state;
    }
}

const patientPlanEligibilityMaskInfoReducer = (state = initialState.allStaticDataNew, action: any) => {
    switch (action.type) {
        case FETCH_ALL_STATIC_DATA_SUCCESS_NEW:
            return Object.assign({}, [{
                    source: "lifestyle_condition",
                    values: [{ displayValue: "YES", internalValue: "yes" }]
                }]
            );
        default:
            return state;
    }
}

export const AllStaticDataReducerNew = combineReducers({
    vitalList: vitalListReducer,
    habitList: habitListReducer,
    doctorSpecialityResponseList: specialistCodeListReducer,
    medicalTypeList: MedicineTypeReducer,
    staticDietRecallData: StaticDietRecallDataReducer,
    surgery: surgeryReducer,
    allergy: allergyReducer,
    lifeStyleProfile: lifeStyleReducer,
    habits: habitReducer,
    pastConditions: pastConditionsReducer,
    redFlags: redFlagsReducer,
    generalExaminations: generalExamsReducer,
    systemicExaminations: systemicExamsReducer,
    entExaminations: entExamsReducer,
    mentalStatusExaminations: mentalStatusExamsReducer,
    reviewOfSystems: reviewSystemsReducer,
    personalInformation: personalInfoReducer,
    personalInformationPhysiotherapist: personInformationPhysiotherapistReducer,
    mindfulnessInformation: mindfulnessInfoReducer,
    allPreferredFoodTypes: foodTypesReducer,
    allPreferredCuisines: cuisinesInfoReducer,
    routineActivities: routineActivitiesReducer,
    foodGroups: foodGroupsReducer,
    typeFormMapping: typeFormReducer,
    lifestylePlanHabits: lifestylePlanHabitsReducer,
    goals: goalsReducer,
    metrics: metricsReducer,
    trackableSymptoms: trackableSymptomsReducer,
    // detailsInformation: detailsInfoReducer,
    fitnessRecallInformation: fitnessRecallInfoReducer,
    labtests: metricsReducer,
    staticPatientPlanEligibilityMaskAnswers: patientPlanEligibilityMaskInfoReducer
});